var _rect, _rect2, _rect3, _polygon, _rect4, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileCtaButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ctaGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#9EC630"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#D4C4A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#C8B59B"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 48,
    height: 24,
    fill: "url(#ctaGradient)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 32,
    height: 4,
    fill: "#FFFFFF",
    rx: 2,
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 34,
    width: 24,
    height: 3,
    fill: "#FFFFFF",
    rx: 1.5,
    opacity: 0.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "46,32 52,28 52,36",
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 48,
    height: 24,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    rx: 12,
    opacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 12,
    r: 4,
    fill: "#9EC630",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0.2;0.6",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 30 8 L 32 4 L 34 8",
    stroke: "#9EC630",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0.2;0.6",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCtaButton);
export default __webpack_public_path__ + "static/media/mobile-cta-button.eeae88519400847590c3614303058579.svg";
export { ForwardRef as ReactComponent };